import React from 'react';
import styled from 'styled-components';
import { Nav } from '@catalogo/core-nav';

type DispatchMetrics = (event: string, data: { [key: string]: string }) => void;

export const HowItWorksLink = ({ dispatchMetrics }: { dispatchMetrics: DispatchMetrics }) => (
  <Link
    to="#modal-seller-reputation-info"
    onClick={() =>
      dispatchMetrics('event:track', {
        event: 'c:click',
        category: 'modal-open',
        action: 'como-funciona',
        label: 'reputacao-seller',
      })
    }
  >
    como funciona a avaliação
  </Link>
);

const Link = styled(Nav)`
  display: block;
  margin-top: 16px;
  font-size: 14px;
  color: #666;
  text-decoration: underline;

  @media screen and (max-width: 768px) {
    padding: 0 8px;
  }
`;
